import { z } from 'zod';
import type { GetFullChatResponse } from '../types/GetFullChatResponse';

export const getFullChatResponseSchema = z.object({
  data: z.array(
    z.object({
      id: z.string().uuid(),
      status: z
        .enum(['pending', 'open', 'closed'])
        .default('pending')
        .optional(),
      subject: z.string().min(4).max(255),
      creator: z.union([
        z.object({
          id: z.string().uuid(),
          auth0Id: z.string(),
          firstName: z.string().min(2).max(64),
          lastName: z.string().min(2).max(64),
          email: z.string().email(),
          backupEmail: z.string().email().nullable(),
          phoneNumber: z.string().nullable(),
          username: z.string().nullable(),
          avatar: z.string().nullable(),
          description: z.string().min(3).max(255).nullable(),
          timeZone: z.string().nullable(),
          createdAt: z.string().datetime({ offset: true }),
          updatedAt: z.string().datetime({ offset: true }),
          role: z.enum(['admin']),
        }),
        z.object({
          id: z.string().uuid(),
          auth0Id: z.string(),
          firstName: z.string().min(2).max(64),
          lastName: z.string().min(2).max(64),
          email: z.string().email(),
          backupEmail: z.string().email().nullable(),
          phoneNumber: z.string().nullable(),
          username: z.string().nullable(),
          avatar: z.string().nullable(),
          description: z.string().min(3).max(255).nullable(),
          timeZone: z.string().nullable(),
          createdAt: z.string().datetime({ offset: true }),
          updatedAt: z.string().datetime({ offset: true }),
          role: z.enum(['teacher']),
          speciality: z.string().nullable(),
          language: z
            .enum(['eng', 'fra', 'spa', 'deu', 'ita', 'ukr'])
            .default('eng')
            .optional()
            .nullable(),
        }),
      ]),
      admin: z.union([
        z.object({
          id: z.string().uuid(),
          auth0Id: z.string(),
          firstName: z.string().min(2).max(64),
          lastName: z.string().min(2).max(64),
          email: z.string().email(),
          backupEmail: z.string().email().nullable(),
          phoneNumber: z.string().nullable(),
          username: z.string().nullable(),
          avatar: z.string().nullable(),
          description: z.string().min(3).max(255).nullable(),
          timeZone: z.string().nullable(),
          createdAt: z.string().datetime({ offset: true }),
          updatedAt: z.string().datetime({ offset: true }),
          role: z.enum(['admin']),
        }),
        z.object({
          id: z.string().uuid(),
          auth0Id: z.string(),
          firstName: z.string().min(2).max(64),
          lastName: z.string().min(2).max(64),
          email: z.string().email(),
          backupEmail: z.string().email().nullable(),
          phoneNumber: z.string().nullable(),
          username: z.string().nullable(),
          avatar: z.string().nullable(),
          description: z.string().min(3).max(255).nullable(),
          timeZone: z.string().nullable(),
          createdAt: z.string().datetime({ offset: true }),
          updatedAt: z.string().datetime({ offset: true }),
          role: z.enum(['teacher']),
          speciality: z.string().nullable(),
          language: z
            .enum(['eng', 'fra', 'spa', 'deu', 'ita', 'ukr'])
            .default('eng')
            .optional()
            .nullable(),
        }),
      ]),
      messages: z.array(
        z.object({
          id: z.string().uuid(),
          text: z.string().min(2).max(255),
          creatorId: z.string().uuid(),
          chatId: z.string().uuid(),
          createdAt: z.string().datetime({ offset: true }),
        }),
      ),
    }),
  ),
  meta: z.object({
    page: z.number().int().min(1).default(1).optional(),
    take: z.number().int().min(1).default(10).optional(),
    numberOfItems: z.number().int(),
    numberOfPages: z.number().int(),
    hasPrevious: z.boolean(),
    hasNext: z.boolean(),
  }),
}) as z.ZodType<GetFullChatResponse>;
